import {marked} from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({breaks: true, gfm: true});

export const renderMarkdown = (text: string): string => {
    if (!text) {
        return '';
    }
    const html = marked.parse(text) as string;
    return DOMPurify.sanitize(html);
};
